import { render, staticRenderFns } from "./TextFieldDecimal.vue?vue&type=template&id=27f87db7&"
import script from "./TextFieldDecimal.vue?vue&type=script&lang=ts&"
export * from "./TextFieldDecimal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports